import { Component } from "@angular/core";

@Component({
	selector: "caass-districtsetup",
	templateUrl: "./districtadmin.component.html",
})
export class DistrictAdminComponent {}
